import { Environment, generateApi } from '@environment';

import { environment as baseEnvironment } from './environment.all.js';

const environmentOverrides: Partial<Environment> = {
  mode: 'prod',

  useProductionData: true,

  api: generateApi({
    url: 'https://api.usheru.com/rest',
    ushChannel: '877f26f7-9ae9-46f2-8145-6f6c50211cbd',
    user: 'cinemalive-api@noemail.com',
    pass: 'secret',
    versionOverrides: {
      v2: ['movies/in-cinemas/', 'movies/watch-at-home/', 'movies/', 'channels/channel-videos/']
    }
  }),

  google: {
    maps_key: 'AIzaSyDZUidGlbVTCPiX2iDQY8x1X_SaYZbenr8'
  }
};

export const environment: Environment = Object.assign({}, baseEnvironment, environmentOverrides);
